/**
 * Units hidden from delegation UI. Add canonical owner IDs here, for example:
 * `avdeling:123456` or `seksjon:654321`. Descendants are hidden automatically.
 */
export const HIDDEN_DELEGATION_UNITS: ReadonlySet<string> = new Set([
  'avdeling:M30000', // Adm.dir.
  'avdeling:M35000', // Avdeling brukerdialog og kommunikasjon
  'avdeling:M33000', // Avdeling juridisk og internasjonalt arbeid
  'avdeling:M32000', // Avdeling regelverk og kontroll
  'avdeling:M31000', // Avdeling styring
  'avdeling:M34000', // Avdeling utvikling
  'avdeling:M44600', // avdeling godkjenninger
  'avdeling:M41300', // avdeling innovasjon, metode og analyse A
  'avdeling:M42100', // avdeling innovasjon, metode og analyse L
  'avdeling:M43100', // avdeling innovasjon, metode og analyse M
  'avdeling:M44100', // avdeling innovasjon, metode og analyse P
  'avdeling:M42400' // avdeling innsyn og søknader
])
